import { render, staticRenderFns } from "./PokemonTypeBadge.vue?vue&type=template&id=d85459bc&"
import script from "./PokemonTypeBadge.vue?vue&type=script&lang=ts&"
export * from "./PokemonTypeBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports